var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTagsSlashSolid = function SvgTagsSlashSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 32 32",
    className: "svgr-icon"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m14.6 4-.3.3-11 11-.7.7.7.7 9 9 .7.7.7-.7 11-11 .3-.3V4zm.8 2H23v7.6l-10 10L5.4 16zM26 7v2h1v8.2l-9.5 9.4-1.3-1.3-1.4 1.4 1.9 2 .7.7.7-.7 10.5-10.4.4-.3V7zm-6 1c-.6 0-1 .4-1 1s.4 1 1 1 1-.4 1-1-.4-1-1-1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 8.3 3.7 1.5 2.3 2.9l6.2 6.2 11.1 11.1 1.9 1.9 6.8 6.8 1.4-1.4-6.2-6.2"
  })));
};
export default SvgTagsSlashSolid;